export default __webpack_public_path__ + "static/media/sorry-page-weight-loss.f694a9b6.png";